<template>
    <div>
        <card>
            <template slot="header">
                Custom Fields
            </template>
            <div class="row">
                <div class="col-12 d-flex justify-content-end">
                    <router-link
                        v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].editCheckpoints)"
                        :to="{ name: 'checkpointfields-create' }">
                            <el-button type="primary" class="btn btn-primary">
                                New
                            </el-button>
                    </router-link>
                </div>
            </div>
            <el-table :data="fields">
                <el-table-column label="Title" prop="title" min-width="200px"/>
                <el-table-column label="Name" prop="name" min-width="200px"/>
                <el-table-column label="Type" prop="type" min-width="200px"/>
                <el-table-column label="Actions" min-width="300px">
                    <template slot-scope="props" v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].editCheckpoints)">
                        <router-link
                            :to="{ name: 'checkpointfields-edit', params: { fieldId: props.row._id } }">
                                <el-tooltip content="Edit" placement="top">
                                    <el-button class="btn" title="Edit">
                                        <fa :icon="['fas', 'pen']"/>
                                    </el-button>
                                </el-tooltip>
                        </router-link>
                        <el-tooltip 
                            content="Delete" 
                            placement="top">
                            <el-button
                                @click="remove(props.row._id)"
                                class="btn btn-danger ml-1"
                                title="Delete">
                                    <fa :icon="['fas', 'trash']"/>
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </card>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import { mapState } from 'vuex'
import http from '../../http.js'

export default {
    data () {
        return {
            showUsedTypes: false,
            types: [],
            activities: [],
            dependantFields: [],
            forceDeleteId: null,
            fields: [],
            cloning: {}
        }
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ])
    },
    mounted () {
        this.getFields()
    },
    methods: {
        getFields: async function () {
            try {
                const response = await http.get(`/api/checkpointfields?eventId=${this.$route.params.eventId}`)
                this.fields = response.data.fields
            } catch (e) {
                console.log('erorr getting fields')
            }
        },
        remove: async function (id, force = false) {
            try {
                if (!force) {
                    let { value: confirmed } = await swal({
                        title: `Are you sure you want to delete the field?`,
                        buttonsStyling: false,
                        showCancelButton: true,
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        cancelButtonClass: 'btn btn-default btn-fill'
                    })
    
                    if (!confirmed) {
                        return
                    }
                }

                let query = ''
                if (force) {
                    query = 'force=true'
                }

                const response = await http.delete(`/api/checkpointfields/${id}?eventId=${this.$route.params.eventId}`)
                this.fields = this.fields.filter(field => field._id !== id)
                this.$notify(response.data.message)
            } catch (e) {
                this.$store.dispatch('handleErrors', e);
            }
        },
    }
}
</script>
